import ZeekMapsIcon from "@/components/ui/icons/ZeekMapsIcon";
import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
	NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { RandomLetterSwapPingPong } from "@/components/ui/random-letter-swap";
import { SITE_NAME } from "@/lib/constants";
import { Library, LightbulbIcon, MapIcon } from "lucide-react";
import Link from "next/link";
import type React from "react";

export interface MenuOption {
	label: string;
	href: string;
	onClick?: () => void;
	description: string;
	icon: React.ReactNode;
	forOwner?: boolean;
	group?: "primary" | "secondary" | "tertiary";
	divider?: boolean;
}

const CompanyMenuOptions: MenuOption[] = [
	{
		label: "Home",
		href: "/",
		icon: (
			<MapIcon className="size-6 fill-primary/40 stroke-primary group-hover:stroke-[2px]" />
		),
		description: "Our latest features",
		group: "primary",
	},
	{
		label: "Products",
		href: "/products",
		description: "Browse our products",
		icon: (
			<LightbulbIcon className="size-6 fill-primary/40 stroke-primary group-hover:stroke-[2px]" />
		),
		group: "primary",
	},
	// {
	// 	label: "Resources",
	// 	href: "/resources",
	// 	description: "Helping you get started",
	// 	icon: (
	// 		<CircleQuestionMarkIcon className="size-6 fill-primary/40 stroke-primary group-hover:stroke-[2px]" />
	// 	),
	// 	group: "primary",
	// },
	{
		label: "Blog",
		href: "/blog",
		description: "Read our updates",
		icon: (
			<Library className="size-6 fill-primary/40 stroke-primary group-hover:stroke-[2px]" />
		),
		group: "primary",
	},
	// {
	// 	label: "Pricing",
	// 	href: "/pricing",
	// 	description: "Our pricing plans",
	// 	icon: (
	// 		<DollarSign className="size-6 fill-primary/40 stroke-primary group-hover:stroke-[2px]" />
	// 	),
	// 	group: "primary",
	// },
];

const CompanyMenu = () => {
	return (
		<NavigationMenu>
			<NavigationMenuList>
				<NavigationMenuItem>
					<NavigationMenuTrigger className="mt-1 text-primary bg-none! h-auto px-1 py-0.5 w-auto">
						<div className="w-full group">
							<Link
								href="/"
								className="flex w-full flex-row gap-1 items-center cursor-pointer"
							>
								<ZeekMapsIcon className="size-8 group-hover:rotate-12 transition-all" />
								<h1 className="text-primary text-nowrap leading-[32px] font-extrabold text-[20px] tracking-tighter">
									<RandomLetterSwapPingPong label={SITE_NAME} />
								</h1>
							</Link>
						</div>
					</NavigationMenuTrigger>
					<NavigationMenuContent>
						<div className="flex flex-col">
							<ul className="grid w-[200px] gap-2 p-2">
								{CompanyMenuOptions.map((item) => (
									<li
										key={item.label}
										className="p-2 rounded-md hover:bg-primary/20"
									>
										<NavigationMenuLink asChild>
											<Link
												href={item.href}
												className="flex flex-row items-center gap-2 cursor-pointer"
											>
												{item.icon ? item.icon : null}
												<div className="flex flex-col">
													<div className="font-medium text-sm">
														{item.label}
													</div>
													<div className="text-muted-foreground text-xs">
														{item.description}
													</div>
												</div>
											</Link>
										</NavigationMenuLink>
									</li>
								))}
							</ul>
						</div>
					</NavigationMenuContent>
				</NavigationMenuItem>
			</NavigationMenuList>
		</NavigationMenu>
	);
};

export default CompanyMenu;
